import React from 'react';
import {useForm} from 'react-hook-form';
import {zodResolver} from '@hookform/resolvers/zod';
import { Link } from '@tanstack/react-router';
import { RiPhoneLine, RiMailLine, RiMapPinLine, RiInstagramLine } from '@remixicon/react';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/atoms/form.tsx';
import { z } from 'zod';
import {Input} from '@/components/atoms/input.tsx';
import {Button} from '@/components/atoms/button.tsx';

const subscribeFormSchema = z.object({
  email: z.string().email(),
});

export default function Footer() {
  const subscribeForm = useForm<z.infer<typeof subscribeFormSchema>>({
    resolver: zodResolver(subscribeFormSchema),
    defaultValues: {
      email: '',
    }
  });

  const handleSubscribe = (values: z.infer<typeof subscribeFormSchema>) => {
    console.log(values);
  };

  return(
    <div className="footer-container">
      <div className="footer-row">
        <div className="footer-left">
          <h3 className="footer-subtitle">Website Links</h3>
          <ul className="footer-menu">
            <li>
              <Link to="/">
                Home
              </Link>
            </li>
            <li>
              <Link to="/contact-us">
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/about">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/my-account">
                My Account
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/disclaimer">
                Disclaimer
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-center">
          <h3 className="footer-subtitle">Bike Links</h3>
          <ul className="footer-menu">
            <li>
              <Link to="/systems">
              TAVELO Arow Race Alpha
              </Link>
            </li>
            <li>
              <Link to="/systems">
              TAVELO Arow Race Pleid
              </Link>
            </li>
            <li>
              <Link to="/systems">
              TAVELO Wild
              </Link>
            </li>
            <li>
              <Link to="/systems">
              SEKA Spear
              </Link>
            </li>
            <li>
              <Link to="/systems">
              SEKA Exceed
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-right">
          <div className="footer-contact-row">
            <div className="footer-contact-left-col">
              <RiMapPinLine />
            </div>
            <div className="footer-contact-right-col">
              66 Edward Street<br />
              Carlton NSW 2218
            </div>
          </div>
          <div className="footer-contact-row">
            <div className="footer-contact-left-col">
              <RiMailLine />
            </div>
            <div className="footer-contact-right-col">
              <a href="mailto:sales@omeo.cc">sales@omeo.cc</a>
            </div>
          </div>
          <div className="footer-contact-row">
            <div className="footer-contact-left-col">
              <RiPhoneLine />
            </div>
            <div className="footer-contact-right-col">
              <a href="tel:0295194764">02 9519 4764</a>
            </div>
          </div>
          <div className="footer-contact-row">
            <div className="footer-contact-left-col">
              <RiInstagramLine />
            </div>
            <div className="footer-contact-right-col">
              <a target="_new" href="https://www.instagram.com/omeocycles/?next=%2F">instagram.com/omeocycles</a>
            </div>
          </div>
          <div className="footer-contact-row mt-20">
            <div className="footer-payments">
              <div className="footer-payment-text">
                All major credit cards accepted.
              </div>
              <div className="footer-payment-container">
                <img src="/public/card-1.png" className="footer-payment-method" />
                <img src="/public/card-3.png" className="footer-payment-method" />
                <img src="/public/card-6.png" className="footer-payment-method" />
                <img src="/public/card-7.png" className="footer-payment-method" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-row bt">
        <div className="newsletter-signup-text">Sign up to our newsletter to receive special offers, and news on the latest products.</div>
        <div className="newsletter-signup">
          <Form {...subscribeForm}>
            <form id="subscribeForm" onSubmit={subscribeForm.handleSubmit(handleSubscribe)}>
              <div className="newsletter-signup-input">
                  <FormField
                    control={subscribeForm.control}
                    name="email"
                    render={({field }) => (
                    <FormItem>
                    <FormControl>
                    <Input placeholder="Email address" type="email" {...field} />
                    </FormControl>
                    <FormMessage />
                    </FormItem>)}
                    />
              </div>
              <div className="newsletter-signup-btn">
                <Button type="submit">
                  Subscribe
                </Button>
              </div>
            </form>
          </Form>
        </div>
      </div>
      <div className="footer-row">
        <div className="footer-copyright">
          Copyright 2025 Excelera Pty Ltd
        </div>
      </div>
    </div>
  )
}
